import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  ListItem,
  Text,
  UnorderedList,
  Link,
} from '@chakra-ui/react';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';

const IndividualBlog: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="300px"
      minH="300px"
      maxH="300px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        // eslint-disable-next-line no-constant-condition
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '32px', sm: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus : Know how Roadmap-driven investing approach makes it
          Bessemer VP’s biggest differentiator
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Anant Vidur Puri, Partner, Bessemer Venture Partners
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to Anant Vidur Puri, Partner,
          <Flex
            display="inline-flex"
            alignItems="center"
            _hover={{ textDecoration: 'underline' }}
            cursor="pointer"
          >
            <Text variant="blogAnswer" textDecor="underline">
              <a
                href="https://www.bvp.com/india"
                target="_blank"
                rel="noreferrer"
              >
                Bessemer Venture Partners&nbsp;
              </a>
            </Text>
          </Flex>
          &nbsp;to learn more about high potential opportunities in the Indian
          consumer internet marketplaces.
        </Text>
      </Box>

      <Img
        src="/jpg/avpuri.jpg"
        alt="AV Puri"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="cover"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Anant Vidur Puri, Partner, Bessemer Venture Partners
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link href="https://www.linkedin.com/in/avpuri/" target="_blank">
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
            <Box alignSelf="center">
              <Link href="https://twitter.com/avpuri" target="_blank">
                <IconButton
                  aria-label="twitter"
                  icon={
                    <FaTwitter size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. As a global fund, Bessemer VP launched its first India focused
            fund last year. Elaborate the strategy behind having a dedicated
            fund for a region. How has the new capital been deployed so far?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Bessemer Venture Partners believes that innovation and
            entrepreneurship are not limited to a city or country. With this
            ideology, our platform of partners and portfolio companies spans
            across the globe, enabling us to back diverse and dynamic founders
            and CEOs. In 2021, we announced the first India-dedicated fund of
            $220 million. While the global funds continue to back our
            investments in India, the new fund introduced is another pool raised
            to back early-stage companies, investing in seed and Series A
            rounds. The dedicated fund exemplifies our confidence in the massive
            growth opportunities within India and allows us to support more
            entrepreneurs in their journeys.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. Moving on from the initial focus on consumer internet companies,
            today the fund is more geared to back tech/ SaaS start-ups and
            enterprises. What is the approach of Bessemer VP to identify
            successful investments in this category?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Bessemer’s consumer internet roadmap in India has been evolving
              over time. In 2011, the firm started investing in consumer
              internet with listing marketplaces like Bharat matrimony and later
              move on to investing in full-stack, vertical, transactional
              marketplaces like BigBasket, Swiggy, UrbanCompany. We are now
              looking at marketplaces targeting newer consumer segments
              including SaaS enabled marketplaces with software embedded into
              the ecosystem, which may turn out to be more B2B. Marketplaces
              thrive when both sides (demand and supply) of the world are
              fragmented. In India, a lot of the supply side is disorganised
              across different categories. So, the more fragmented the supply,
              the better the marketplace can be. Once a marketplace business is
              built, it is very hard to replicate. These businesses usually end
              up being monopolies, duopoly or oligopolies and thus the value
              generation is much higher. We have built out four key roadmaps in
              India - Consumer Internet and Marketplaces, SaaS, Fintech and
              Health-Tech and continue to build more!
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}

        <Box py="16px">
          <Heading variant="blogQuestion" pt="28px">
            3. Share some interesting work by a few of your new portfolio
            companies in terms of market problems they are trying to solve,
            competitive advantage and impact generated so far.
          </Heading>
          <Img
            mt="20px"
            src="/jpg/bvp.jpg"
            alt="answer-list"
            w={{ md: '440px', lg: '500px' }}
            h="auto"
            float={{ xs: 'none', md: 'left' }}
            mx={{ xs: 'auto', md: '0px' }}
            mr={{ xs: '0px', md: '45px' }}
            mb="20px"
            objectFit="contain"
            display={{ xs: 'none', md: 'block' }}
          />
          <Flex w="100%" justify="center" display={{ xs: 'flex', md: 'none' }}>
            <Img
              mt="20px"
              src="/jpg/bvp.jpg"
              w={{ xs: '90%', sm: '90%' }}
              h="auto"
              alt="answer-list"
              mr={{ xs: '0px', md: '55px' }}
              mb="20px"
              objectFit="contain"
            />
          </Flex>
          {/* 1st set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Plobal Apps</Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  With the rise of omni-channel-commerce, having a dedicated
                  mobile app has become necessary. While the teams at Plobal
                  Labs were building applications for global e-commerce players
                  since 2016, they realised that custom development was
                  something that only a handful of retailers or brands could
                  afford.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Today, Plobal builds the native mobile apps for Shopify
                  storefronts and enables these apps to go live in 24-hours or
                  less. Brands do not have to invest upfront in technology and
                  only pay when the app yields transactions.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  The results speak for themselves: app check-out conversion
                  rates are approximately 2-4x higher on Plobal mobile apps
                  versus the same store’s mobile web, whereas the open-rates on
                  push notifications are about 2-5x higher compared to SMS or
                  email campaigns sent by the same store.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  In addition, the app seamlessly ports over all existing
                  integrations on the store and allows a range of additional
                  functionalities like LiveStreaming, Deep Linking amongst many
                  others.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Today, Plobal counts some of the most recognizable Shopify
                  brands such as Steve Madden, Goose Creek, Matt & Nat, Koovs,
                  and Rare Rabbit as customers. Plobal is one of the many
                  examples we are seeing in India’s entrepreneurial ecosystem
                  where strong leadership and product innovation are having a
                  global impact.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 2nd set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Zopper</Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  In the last couple of years, companies across different
                  sectors have leaned into insurance as a service.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Zopper is a leading Insur-Tech platform that connects
                  insurance carriers with online and offline ecosystem partners
                  to sell curated insurance products for consumers by
                  integrating into their daily activities and experiences.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  With more people looking for protection across assurance and
                  insurance, we are excited to see the Zopper team continue to
                  strengthen its infrastructure rails and build an enduring
                  company.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  At the core, Zopper also aims to build trust within the
                  ecosystem by enabling insurance distribution through working
                  with over 60 partners in lifestyle, digital, and financial
                  ecosystems. Some of the most recognisable distribution
                  partners Zopper works with include HDFC Bank, IIFL, Croma,
                  Xiaomi, Amazon, Ola, Cars24, and Titan Eye Plus among others.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 3rd set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Zenskar</Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  As global SaaS spend continues to increase, pricing is
                  evolving from vanilla subscriptions to granular,
                  consumption-based pricing. Oftentimes, product launches and
                  pricing changes get delayed because of limitations with
                  billing tools. Additionally, these SaaS companies have to
                  devote significant engineering resources to automate their
                  billing processes.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Zenskar offers a flexible billing platform that enables SaaS
                  companies to handle complexities in pricing that include
                  usage-based pricing, subscriptions, nuanced discounts,
                  credits, custom currencies, prepaid, post-paid, ramp deals,
                  etc. They not only overcome billing related limitations, but
                  also further automates accounting, streamlines receivables
                  management workflows and provides robust analytics.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Zenskar, further integrates with the entire stack of a
                  company, including CRM, CPQ and ERP. Through the interface,
                  onboarding can be done by non-technical users, and only takes
                  a few days instead of the months required by legacy billing
                  tools.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  We were impressed with their founders’ deep understanding of
                  customer pain points, and DNA of first principles innovation
                  to provide a radically unique and flexible billing software.
                  Looking forward to partnering with them on the journey to
                  fundamentally disrupt the quote-to-cash tooling for SaaS
                  companies across the globe.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 4th set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Lentra</Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  This Pune-based fintech has demonstrated superior metrics on
                  revenue retention and grown 20-fold since a $12 million Series
                  A round in 2019. It is an online platform designed to change
                  the status quo offering banks zero-risk and instant lending
                  solutions
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Lentra is empowering banks to embrace fully digital processes.
                  Lentra Lending Cloud offers ready-to-use third-party API
                  connectors to various data sources that banks want to join.
                  Lentra has been at the forefront of digital lending
                  transformation since inception. It has more than 50 clients in
                  India and will be using the recent funding for product and
                  platform enhancement to expand overseas in Asia and the USA.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 5th set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Pepper Content </Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  As a content marketplace that connects global brands such as
                  Google, Meta, Amazon and Adobe with over 100,000 creators,
                  Pepper Content helps enterprises identify and work with vetted
                  professionals for their content marketing needs.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Businesses use Pepper’s platform to provide briefs for their
                  content. Pepper’s AI model then allocates the brief to the
                  most relevant/appropriate creators in its creator base taking
                  into account factors such as past performance, timelines,
                  cost/word etc. Creators also get access to a platform where
                  they can manage their briefs, view their earnings, as well as
                  complete content requests.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Once creators create/upload content onto Pepper’s platform it
                  is then graded and curated by a set of editors (a sub-set of
                  creators) post which the customer sees it on their dashboard.
                  The customer can provide feedback/request rework or accept the
                  content. For businesses, this provides a seamless way to scale
                  quality content without too much manual intervention.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  For creators, this provides higher earnings (as compared to
                  agencies), more flexibility of work, as well as an ability to
                  scale a sustainable source of income. In addition, Pepper runs
                  PepperType.ai – a GPT3 based automatic text content creation
                  tool integrated with the PepperContent marketplace to provide
                  a full stack automated platform which would allow marketplace
                  customers to use PepperType to populate their briefs and short
                  form content faster while also allowing PepperType customers
                  to use the marketplace for their long form content.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 6th set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Rupifi </Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  B2B Commerce has seen a wave of digitisation during the past
                  few years with credit becoming an integral part of the B2B
                  Payments ecosystem. Rupifi started with the B2B BNPL Product
                  focusing on the Digital B2B Marketplaces in mid 2020 and has
                  seen significant growth.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Despite the subdued economic activity, Rupifi has managed to
                  record 50 per cent MoM growth in disbursals during the past 12
                  months, covering over 50,000 SMEs. The firm is working with
                  some marquee Marketplaces such as Flipkart Wholesale, Retailio
                  and Fynd among others.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  The team states that their priority has been to create
                  scalable growth without compromising on portfolio quality,
                  which is why, despite the pandemic-induced uncertainty and
                  disruption, Rupifi’s portfolio continues to be healthy with
                  very low NPA levels.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 7th set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Medisage</Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Founded in 2019 by Bhagwat Dhingra, Abhishek Ghosh and Anurag
                  Dhingra, MediSage is a knowledge platform that connects the
                  healthcare ecosystem which includes doctors, nurses, and
                  patient cases to pharmaceutical and diagnostics companies.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  The platform enables doctors and other healthcare
                  practitioners from over 146 countries to discuss and share
                  medical information through virtual communities including
                  those created by a group of over 1500 global subject matter
                  experts, medical associations, drug and device companies and
                  medical universities. We are excited to partner with the team
                  as they plan to strengthen its product and expand its team.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
          {/* 8th set of list */}
          <Box pt="16px">
            <Heading variant="blogQuestion">Cashify </Heading>
            <UnorderedList pl="16px" pt="16px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Cashify operates an eponymous platform — both online and
                  physical stores and kiosks — for users to sell and buy used
                  smartphones, tablets, laptops and other gadgets.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  Additionally, Cashify also works with all top smartphone
                  makers including Apple, Samsung, Xiaomi and Samsung to power
                  their refurbishing programs. The startup repairs and
                  refurbishes those devices, giving them new lives without which
                  they may have likely ended up in the garbage bin.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  The startup is tapping into India’s large market, where over
                  100 million smartphones ship each year and tens of millions of
                  used smartphones get resold.
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  They also have operations outside of India, including in
                  markets including the UAE, Turkey and Bangladesh. In the
                  international regions, the firm licenses its enterprise
                  business. The firm’s enterprise business includes offerings
                  such as a diagnostic tool to evaluate a smartphone’s
                  functional and physical aspects.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box py="16px">
          <Heading variant="blogQuestion" pt="16px">
            4. What excites you about the &apos;India Opportunity&apos;? Which
            sectors will play significant growth drivers for the digital economy
            in future?
          </Heading>
          <Box>
            <Text variant="blogAnswer" py="16px">
              As one of India’s earliest venture capital firms in the business,
              we have experienced several economic cycles and the evolution of
              the country’s private-capital landscape. Over the last one and a
              half decade of our India presence, Bessemer has partnered with
              over 65 startups across a wide range of companies, stages and
              sectors in India. We have taken seven companies public and have
              several unicorns in the portfolio including Urban Company, Big
              Basket, PharmEasy, and the Good Glamm Group. We follow what we
              call the ‘roadmap-driven’ approach to investing, which means that
              we are stage-agnostic. We can come in at the seed, series A,
              series B, series C across the range as long as the company fits
              our roadmap. We have built out four key roadmaps in India -
              Consumer Internet and Marketplaces, SaaS, Fintech and Healthtech
              and continue to build more
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            5. Amidst funding winter there is record dry powder with a high
            potential for investing into Indian startup ecosystem. What is your
            take on this phenomenon and how is BVP approaching it?
          </Heading>

          <Text variant="blogAnswer" pt="8px">
            At Bessemer, we invest in roadmaps and our investment strategy does
            not change with market cycles. We continue to invest at our usual
            pace finding. This year, the company has closed investments across
            stages in Cashify, Rupifi, Medisage, Pepper Content, Plobal Labs,
            Zenskar, Zopper, and Lentra.
          </Text>
        </Box>
      </Box>
    </Container>
  </>
);

export default IndividualBlog;
